<template>
  <View gap="md" direction="column">
    <View gap="sm" direction="column">
      <Text variant="label-medium" color="tertiary">{{ residenceInfo.type }}</Text>
      <Text variant="body-medium">{{ date }}</Text>
      <Text variant="body-medium">{{ residenceInfo.status }}</Text>
      <Text variant="body-medium" v-if="monthlyRent">{{ monthlyRent }}</Text>
      <Text variant="body-medium" v-if="residenceInfo.moveOutReason">
        {{ residenceInfo.moveOutReason }}
      </Text>
    </View>

    <View
      gap="sm"
      direction="column"
      v-if="residenceInfo.landlordName || residenceInfo.landlordEmail || residenceInfo.landlordPhone"
    >
      <Text variant="label-medium" color="tertiary">Owner contact</Text>
      <Text variant="body-medium" v-if="residenceInfo.landlordName">
        {{ residenceInfo.landlordName }}
      </Text>
      <Text variant="body-medium" v-if="residenceInfo.landlordEmail">
        {{ residenceInfo.landlordEmail }}
      </Text>
      <Text variant="body-medium" v-if="residenceInfo.landlordPhone">
        {{ residenceInfo.landlordPhone }}
      </Text>
    </View>
  </View>
</template>

<script setup lang="ts">
import { useDateFormat } from '@vueuse/core';
import { computed } from 'vue';

import { formatCurrency, Text, View } from '@tallo/design-system';

import { ApplicationResidenceInfoDto } from '../../interfaces/residence-info.interface';

const props = defineProps<{ residenceInfo: ApplicationResidenceInfoDto }>();
const monthlyRent = computed(() =>
  props.residenceInfo.monthlyRent ? formatCurrency(props.residenceInfo.monthlyRent) : null,
);
const date = computed(() => {
  const moveInDate = useDateFormat(props.residenceInfo.moveInDate!, 'MMM YYYY').value;
  const moveOutDate = props.residenceInfo.moveOutDate
    ? useDateFormat(props.residenceInfo.moveOutDate, 'MMM YYYY').value
    : 'still presence';

  return `${moveInDate} - ${moveOutDate}`;
});
</script>

<style scoped></style>
